import React from 'react';
import { Dropdown, Badge } from 'react-bootstrap';
import { Award } from './rnr.types';

interface AwardsFilterDropdownProps {
  onAwardSelect: (award: Award | null) => void;
  selectedAward: Award | null;
  awards: Award[];
}

// Helper to get a visual variant for the status badge
const getStatusVariant = (status?: string) => {
  switch (status) {
    case 'Open':
    case 'Always Open':
      return 'success';
    case 'Upcoming':
      return 'warning';
    case 'Closed':
      return 'danger';
    default:
      return 'secondary';
  }
};

const AwardsFilterDropdown = ({ onAwardSelect, selectedAward, awards = [] }: AwardsFilterDropdownProps) => {

  const handleSelect = (award: Award) => {
    onAwardSelect(award);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle id="dropdown-award-filter" variant="dark" className="w-100">
        {selectedAward 
            ? <span className='text-truncate'>{selectedAward.awardCategory}</span>
            : 'Select an Award'
        }
      </Dropdown.Toggle>

      <Dropdown.Menu 
        style={{ 
          maxHeight: '300px',
          width: '400px',
          maxWidth: '500px',
          overflowY: 'auto' 
        }}
      >
        {awards.length > 0 ? awards.map((award) => {
          const status = award.nominationWindowStatus?.status;
          const isDisabled = status === 'Closed' || status === 'Upcoming';

          return (
              <Dropdown.Item
                key={award._id}
                onClick={() => !isDisabled && handleSelect(award)}
                disabled={isDisabled}
                active={selectedAward?._id === award._id}
                className="d-flex justify-content-between align-items-center"
              >
                <span>{award.awardCategory}</span>
                {status && (
                  <Badge bg={getStatusVariant(status)} pill>
                    {status}
                  </Badge>
                )}
              </Dropdown.Item>
          );
        }) : (
            <Dropdown.Item disabled>No awards available</Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AwardsFilterDropdown;